
import { defineComponent } from "vue";
import MediaQueryLayout from "@/layouts/media-query-layout/media-query-layout.vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";
import ToolbarRowButton from "./toolbar-row-button.vue";

export default defineComponent({
  components: { MediaQueryLayout, BaseTypography, ToolbarRowButton },
});
